import * as angular from 'angular';

export interface TransmissionSystemOperatorResource extends ng.resource.IResourceClass<
    ng.resource.IResource<TransmissionSystemOperator>
> {
    get: ng.resource.IResourceMethod<
        ng.resource.IResource<TransmissionSystemOperator>
    >;
    marketAreas: ng.resource.IResourceMethod<ng.resource.IResource<string>>;
    assignedShippersPage: ng.resource.IResourceMethod<
        ng.resource.IResource<DataPageDto<TsoShipperAssignmentsDto>>
    >;
    assignedShippers: ng.resource.IResourceMethod<
        ng.resource.IResource<TsoShipperAssignmentsDto[]>
    >;
    assignedShipperForId: ng.resource.IResourceMethod<
        ng.resource.IResource<TsoShipperAssignmentsDto>
    >;
    saveSecondaryTradeNote: ng.resource.IResourceMethod<
        ng.resource.IResource<string>
    >;
    saveSecondaryLeadTimeNote: ng.resource.IResourceMethod<
        ng.resource.IResource<string>
    >;
    saveSecondaryTransactionTypeSupport: ng.resource.IResourceMethod<
        ng.resource.IResource<{ [index: string]: boolean }>
    >;
    saveAutomaticApprovalOfTradesForAssignment: ng.resource.IResourceMethod<
        ng.resource.IResource<boolean>
    >;
    saveAutomaticApprovalOfTradesForTransferOfUse: ng.resource.IResourceMethod<
        ng.resource.IResource<boolean>
    >;
    saveAllowCompletelyAnonymousTrading: ng.resource.IResourceMethod<
        ng.resource.IResource<boolean>
    >;
    saveEnablePricePublication: ng.resource.IResourceMethod<
        ng.resource.IResource<boolean>
    >;
    saveAllowTraderLists: ng.resource.IResourceMethod<
        ng.resource.IResource<boolean>
    >;
    saveMinimumTradeRuntime: ng.resource.IResourceMethod<
        ng.resource.IResource<boolean>
    >;
    saveAllowBundlingOfUnbundledContracts: ng.resource.IResourceMethod<
        ng.resource.IResource<boolean>
    >;
    getSecondarySettings: ng.resource.IResourceMethod<
        ng.resource.IResource<TsoSecondarySettingsDto>
    >;
    getAuctionSettings: ng.resource.IResourceMethod<
        ng.resource.IResource<TsoAuctionSettingsDto>
    >;
    saveContractIdOnUpgradeSelection: ng.resource.IResourceMethod<
        ng.resource.IResource<{ value: SelectionPossibility }>
    >;
    saveUpgradePossibleForShortTerm: ng.resource.IResourceMethod<
        ng.resource.IResource<boolean>
    >;
    saveUpgradePossibleForLongTerm: ng.resource.IResourceMethod<
        ng.resource.IResource<boolean>
    >;
    toggleUnbundledToBundledConversion: ng.resource.IResourceMethod<
        ng.resource.IResource<boolean>
    >;
    toggleUnbundledToBundledConversionContractIdSelectionPossibility: ng.resource.IResourceMethod<
        ng.resource.IResource<boolean>
    >;
    saveConversionDayAheadSelection: ng.resource.IResourceMethod<
        ng.resource.IResource<boolean>
    >;
    saveConversionMonthlySelection: ng.resource.IResourceMethod<
        ng.resource.IResource<boolean>
    >;
    saveConversionQuarterlySelection: ng.resource.IResourceMethod<
        ng.resource.IResource<boolean>
    >;
    saveConversionYearlySelection: ng.resource.IResourceMethod<
        ng.resource.IResource<boolean>
    >;
    saveMultipleConversionsPerBid: ng.resource.IResourceMethod<
        ng.resource.IResource<boolean>
    >;
    saveAllowRuntimeForConversion: ng.resource.IResourceMethod<
        ng.resource.IResource<boolean>
    >;
    saveMandateLimitBidForConversion: ng.resource.IResourceMethod<
        ng.resource.IResource<boolean>
    >;
    saveContractIdSelectionForFlowCommitmentForReverseAuction: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    saveContractIdSelectionForBuyBackForReverseAuction: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    saveReverseAuctionConfigurationSupported: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    isRAConfigurationSupported: ng.resource.IResourceMethod<
        ng.resource.IResource<boolean>
    >;
    saveAuctionNote: ng.resource.IResourceMethod<ng.resource.IResource<string>>;
    getGeneralSettings: ng.resource.IResourceMethod<
        ng.resource.IResource<TsoGeneralSettingsDto>
    >;
    querySecondarySettingsTradingConditions: ng.resource.IResourceMethod<
        ng.resource.IResource<TradingConditionsSecondarySettingsDto>
    >;
    getLeadTimeHint: ng.resource.IResourceMethod<
        ng.resource.IResource<{ hint: string }>
    >;
    queryHolidays: ng.resource.IResourceMethod<ng.resource.IResource<string[]>>;
    deleteHolidays: ng.resource.IResourceMethod<
        ng.resource.IResource<string[]>
    >;
    createHoliday: ng.resource.IResourceMethod<ng.resource.IResource<string[]>>;
    saveTradingProcedureSupport: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    saveAutomaticCancellationOfInterruptibleDayAhead: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    disableAutomaticCancellationOfInterruptibleDayAhead: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    createFcfsLeadTimeRule: ng.resource.IResourceMethod<
        ng.resource.IResource<LeadTimeRuleDto>
    >;
    updateFcfsLeadTimeRule: ng.resource.IResourceMethod<
        ng.resource.IResource<LeadTimeRuleDto>
    >;
    deleteFcfsLeadTimeRule: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    disableFcfsLeadTimeRule: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    saveSpecificConditionsEnabled: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    saveSpecificConditionTitle: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    saveSpecificConditionNote: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    disableSpecificConditions: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    toggleInformAboutAssignmentManager: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    queryMaintenanceMessages: ng.resource.IResourceMethod<
        ng.resource.IResource<MaintenanceMessageDto[]>
    >;
    saveMaintenanceMessage: ng.resource.IResourceMethod<
        ng.resource.IResource<MaintenanceMessageDto>
    >;
    deleteMaintenanceMessage: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    queryShipperUserToTsoAssignments: ng.resource.IResourceMethod<
        ng.resource.IResource<ShipperUserDto>
    >;
    approveShipper: ng.resource.IResourceMethod<ng.resource.IResource<void>>;
    approveShipperUser: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    disableShipperUser: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    temporarilyDisableShipperUser: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    rejectShipperUser: ng.resource.IResourceMethod<ng.resource.IResource<void>>;
    queryBalancingGroupsOfAssignedShipper: ng.resource.IResourceArrayMethod<
        ng.resource.IResource<BalancingGroupDto[]>
    >;
    queryPortfolioCodesOfAssignedShipper: ng.resource.IResourceArrayMethod<
        ng.resource.IResource<PortfolioCodeDto[]>
    >;
    getCreditLimitSettings: ng.resource.IResourceArrayMethod<
        ng.resource.IResource<TsoCreditLimitSettingsDto>
    >;
    enableCreditLimitsForAuctionsAndFcfs: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    enableCreditLimitsForSecondaryMarket: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    showCreditLimitsToShippers: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    deactivateCreditLimitSettings: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    getEnabledSettings: ng.resource.IResourceMethod<
        ng.resource.IResource<PossibleSettings[]>
    >;
    deactivateVolumeBasedTariff: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    updateYearlyVolBasedTariff: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    updateQuarterlyVolBasedTariff: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    updateMonthlyVolBasedTariff: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    updateDailyVolBasedTariff: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    saveBalancingGroupPortfolioCodeSelection: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    saveBalancingGroupPortfolioCodeSetting: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    getNumberOfNetworkPointsWithEnabledVolumeBasedTariff: ng.resource.IResourceMethod<
        ng.resource.IResource<number>
    >;
    saveRequireBalancingGroupForTransferOfUseTrades: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    saveValidatePortfolioCodeForDirection: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    getBalancingGroupPortfolioCodeSelection: ng.resource.IResourceMethod<
        ng.resource.IResource<BalancingGroupPortfolioCodeSelection>
    >;
    createContractingService: ng.resource.IResourceMethod<
        ng.resource.IResource<ContractingServiceDto>
    >;
    updateContractingService: ng.resource.IResourceMethod<
        ng.resource.IResource<ContractingServiceDto>
    >;
    deleteContractingService: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    deleteAllContractingServices: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    saveUnderlyingDealSourceConfig: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    saveSelectionPossibilityOfContractIdOnManualUnderlyingDeals: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    saveSupportToPreFillPriceFromUnderlyingDeal: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    saveSupportToChangePriceOfUnderlyingDeal: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    saveSurchargeSelectionPossibility: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    hideRegulatedTariffForUnderlyingDeals: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    allowUpdateOfRegulatedTariffForUnderlyingDeals: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    uploadAdditionalTradingConditions: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    deleteAdditionalTradingConditions: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    saveValidationPeriod: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    querySurrenderSettings: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    deactivateSurrenderSettings: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    saveEnableSurrenderForShortTerm: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    saveEnableSurrenderForLongTerm: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    saveContractIdSelection: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    saveReceiveCopyOfConfirmationMail: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    saveAllowForPendingShippers: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    saveHourForMinimalLeadTime: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    saveMinuteForMinimalLeadTime: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    saveMinimalLeadTime: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    saveExpectMultipleOfAMonth: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    queryShipperRegistrationDocuments: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    deleteTsoDocument: ng.resource.IResourceMethod<ng.resource.IResource<void>>;
    deleteAllTsoDocuments: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    uploadShipperRegistrationDocument: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    queryDocuments: ng.resource.IResourceMethod<ng.resource.IResource<void>>;
    deleteAllDocuments: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    disableSecondaryFlexibleLeadTimeRules: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    queryExtraRegistrationForm: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    saveExtraRegistrationForm: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    previewExtraRegistrationForm: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    deleteExtraRegistrationForm: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    queryMarketAreaNotifications: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    toggleMarketAreaMailOnShipperRegistration: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    deactivateAllMarketAreaNotifications: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    queryUsers: ng.resource.IResourceMethod<ng.resource.IResource<void>>;
    getTsoUser: ng.resource.IResourceMethod<ng.resource.IResource<void>>;
    updateTsoUser: ng.resource.IResourceMethod<ng.resource.IResource<void>>;
    activateTsoUser: ng.resource.IResourceMethod<ng.resource.IResource<void>>;
    deactivateTsoUser: ng.resource.IResourceMethod<ng.resource.IResource<void>>;
    toggleAdminTsoUser: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    prepareTsoUsersListPdf: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    prepareTsoUserDetailsAndAssignmentPdf: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    prepareTsoUserDetailsAndAssignmentCsv: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    prepareTsoUsersListCsv: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    deleteAllAdditionalConditions: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    getContactEmails: ng.resource.IResourceMethod<ng.resource.IResource<void>>;
    saveContactEmails: ng.resource.IResourceMethod<ng.resource.IResource<void>>;
}

angular
    .module('app')
    .factory('TransmissionSystemOperator', transmissionSystemOperatorService);

function transmissionSystemOperatorService($resource, API_URL) {
    return <TransmissionSystemOperatorResource>$resource(
        API_URL.TSO,
        { id: '@id' },
        {
            submitContractingService: {
                method: 'POST',
                url: API_URL.TSO + '/contractingServices/:service',
                params: { service: '@service' }
            },
            marketAreas: {
                method: 'GET',
                url: API_URL.TSO + '/marketAreas',
                isArray: true
            },
            assignedShippersPage: {
                method: 'GET',
                url: API_URL.TSO + '/assigned-shippers/page'
            },
            assignedShippers: {
                method: 'GET',
                isArray: true,
                url: API_URL.TSO + '/assigned-shippers'
            },
            assignedShipperForId: {
                method: 'GET',
                url: API_URL.TSO + '/assigned-shippers/:customerRefId',
                params: { customerRefId: '@customerRefId' }
            },
            assignedShippersCsv: {
                method: 'GET',
                url: API_URL.TSO + '/assigned-shippers/csv'
            },
            approveShipper: {
                method: 'POST',
                url: API_URL.TSO + '/approve-shipper/:shipperId',
                params: {
                    shipperId: '@shipperId',
                    primaryTradingAccess: '@primaryTradingAccess',
                    secondaryTradingAccess: '@secondaryTradingAccess'
                }
            },
            rejectShipper: {
                method: 'POST',
                url: API_URL.TSO + '/reject-shipper/:shipperId',
                params: { shipperId: '@shipperId' }
            },
            disableShipper: {
                method: 'POST',
                url: API_URL.TSO + '/disable-shipper/:shipperId',
                params: { shipperId: '@shipperId' }
            },
            tempDisableShipper: {
                method: 'POST',
                url: API_URL.TSO + '/tmp-disable-shipper/:shipperId',
                params: { shipperId: '@shipperId' }
            },
            enableShipper: {
                method: 'POST',
                url: API_URL.TSO + '/enable-shipper/:shipperId',
                params: { shipperId: '@shipperId' }
            },
            getSecondarySettings: {
                method: 'GET',
                url: API_URL.TSO + '/secondary-settings'
            },
            saveSecondaryTradeNote: {
                method: 'POST',
                url: API_URL.TSO + '/secondary-settings/trade-note'
            },
            saveSecondaryLeadTimeNote: {
                method: 'POST',
                url: API_URL.TSO + '/secondary-settings/lead-time-note'
            },
            saveSecondaryTransactionTypeSupport: {
                method: 'POST',
                url: API_URL.TSO + '/secondary-settings/transaction-type'
            },
            saveAutomaticApprovalOfTradesForAssignment: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/secondary-settings/automatic-approval-assignment'
            },
            saveAutomaticApprovalOfTradesForTransferOfUse: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/secondary-settings/automatic-approval-transfer-of-use'
            },
            saveAllowCompletelyAnonymousTrading: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/secondary-settings/allow-completely-anonymous'
            },
            saveEnablePricePublication: {
                method: 'POST',
                url:
                    API_URL.TSO + '/secondary-settings/enable-price-publication'
            },
            saveAllowTraderLists: {
                method: 'POST',
                url: API_URL.TSO + '/secondary-settings/allow-trader-lists'
            },
            saveMinimumTradeRuntime: {
                method: 'POST',
                url: API_URL.TSO + '/secondary-settings/minimum-trade-runtime'
            },
            saveAllowBundlingOfUnbundledContracts: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/secondary-settings/allow-bundling-unbundled-contracts'
            },
            getAuctionSettings: {
                method: 'GET',
                url: API_URL.TSO + '/auction-settings'
            },
            saveContractIdOnUpgradeSelection: {
                method: 'POST',
                url: API_URL.TSO + '/auction-settings/upgrade/contract-id'
            },
            saveUpgradePossibleForShortTerm: {
                method: 'POST',
                url: API_URL.TSO + '/auction-settings/upgrade/short-term'
            },
            saveUpgradePossibleForLongTerm: {
                method: 'POST',
                url: API_URL.TSO + '/auction-settings/upgrade/long-term'
            },
            toggleUnbundledToBundledConversion: {
                method: 'POST',
                url: API_URL.TSO + '/auction-settings/conversion'
            },
            toggleUnbundledToBundledConversionContractIdSelectionPossibility: {
                method: 'POST',
                url: API_URL.TSO + '/auction-settings/conversion/contract-id'
            },
            saveConversionDayAheadSelection: {
                method: 'POST',
                url: API_URL.TSO + '/auction-settings/conversion/day-ahead'
            },
            saveConversionMonthlySelection: {
                method: 'POST',
                url: API_URL.TSO + '/auction-settings/conversion/monthly'
            },
            saveConversionQuarterlySelection: {
                method: 'POST',
                url: API_URL.TSO + '/auction-settings/conversion/quarterly'
            },
            saveAllowRuntimeForConversion: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/auction-settings/conversion/shipper-runtime-selection'
            },
            saveMandateLimitBidForConversion: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/auction-settings/conversion/shipper-limitbid-selection'
            },
            saveConversionYearlySelection: {
                method: 'POST',
                url: API_URL.TSO + '/auction-settings/conversion/yearly'
            },
            saveMultipleConversionsPerBid: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/auction-settings/conversion/multiple-conversions-per-bid'
            },
            saveContractIdSelectionForFlowCommitmentForReverseAuction: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/auction-settings/reverse-auctions/contract-id-flow-commitment-selection'
            },
            saveReverseAuctionConfigurationSupported: {
                method: 'POST',
                url:
                    API_URL.TSO + '/auction-settings/reverse-auctions/supported'
            },
            isRAConfigurationSupported: {
                method: 'GET',
                url:
                    API_URL.TSO +
                    '/auction-settings/reverse-auctions/supported',
                interceptor: {
                    response: (response: ng.resource.IResourceResponse) =>
                        response.data
                }
            },
            saveContractIdSelectionForBuyBackForReverseAuction: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/auction-settings/reverse-auctions/contract-id-buy-back-selection'
            },
            saveAuctionNote: {
                method: 'POST',
                url: API_URL.TSO + '/auction-settings/auction-note'
            },
            getGeneralSettings: {
                method: 'GET',
                url: API_URL.TSO + '/general-settings'
            },
            querySecondarySettingsTradingConditions: {
                method: 'GET',
                url: API_URL.TSO + '/secondary-settings/trading-conditions',
                isArray: true
            },
            getLeadTimeHint: {
                method: 'GET',
                url: API_URL.TSO + '/leadTimeHint'
            },
            queryHolidays: {
                method: 'GET',
                url: API_URL.TSO + '/holidays',
                isArray: true
            },
            deleteHolidays: {
                method: 'POST',
                url: API_URL.TSO + '/delete-holidays',
                isArray: true
            },
            createHoliday: {
                method: 'PUT',
                url: API_URL.TSO + '/holidays'
            },
            saveTradingProcedureSupport: {
                method: 'POST',
                url: API_URL.TSO + '/secondary-settings/trading-procedures'
            },
            saveAutomaticCancellationOfInterruptibleDayAhead: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/auction-settings/automatic-cancellation-of-interruptible-day-ahead'
            },
            disableAutomaticCancellationOfInterruptibleDayAhead: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/auction-settings/automatic-cancellation-of-interruptible-day-ahead/disable'
            },
            createFcfsLeadTimeRule: {
                method: 'POST',
                url: API_URL.TSO + '/fcfs-settings/lead-time-rules'
            },
            updateFcfsLeadTimeRule: {
                method: 'PUT',
                url: API_URL.TSO + '/fcfs-settings/lead-time-rules/:leadTimeId'
            },
            deleteFcfsLeadTimeRule: {
                method: 'DELETE',
                url: API_URL.TSO + '/fcfs-settings/lead-time-rules/:leadTimeId'
            },
            disableFcfsLeadTimeRule: {
                method: 'POST',
                url: API_URL.TSO + '/fcfs-settings/disable-flexible-lead-times/'
            },
            saveSpecificConditionTitle: {
                method: 'POST',
                url: API_URL.TSO + '/general-settings/specific-condition-title'
            },
            saveSpecificConditionNote: {
                method: 'POST',
                url: API_URL.TSO + '/general-settings/specific-condition-note'
            },
            saveSpecificConditionsEnabled: {
                method: 'POST',
                url:
                    API_URL.TSO + '/general-settings/specific-condition-enabled'
            },
            disableSpecificConditions: {
                method: 'POST',
                url:
                    API_URL.TSO + '/general-settings/specific-condition-disable'
            },
            toggleInformAboutAssignmentManager: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/general-settings/inform-about-assignment-manager'
            },
            queryMaintenanceMessages: {
                method: 'GET',
                url: API_URL.TSO + '/maintenance-messages',
                isArray: true
            },
            saveMaintenanceMessage: {
                method: 'POST',
                url: API_URL.TSO + '/maintenance-messages/:maintenanceMessageId'
            },
            deleteMaintenanceMessage: {
                method: 'DELETE',
                url: API_URL.TSO + '/maintenance-messages/:maintenanceMessageId'
            },
            queryShipperUserToTsoAssignments: {
                method: 'GET',
                url: API_URL.TSO + '/shippers/:shipperRefId/assignments',
                isArray: true
            },
            approveShipperUser: {
                method: 'POST',
                url: API_URL.TSO + '/shipper-users/:shipperUserRefId/approve',
                params: { id: '@id', shipperUserRefId: '@shipperUserRefId' }
            },
            disableShipperUser: {
                method: 'POST',
                url: API_URL.TSO + '/shipper-users/:shipperUserRefId/disable',
                params: { id: '@id', shipperUserRefId: '@shipperUserRefId' }
            },
            temporarilyDisableShipperUser: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/shipper-users/:shipperUserRefId/disable-temporarily',
                params: { id: '@id', shipperUserRefId: '@shipperUserRefId' }
            },
            rejectShipperUser: {
                method: 'POST',
                url: API_URL.TSO + '/shipper-users/:shipperUserRefId/reject',
                params: { id: '@id', shipperUserRefId: '@shipperUserRefId' }
            },
            queryBalancingGroupsOfAssignedShipper: {
                method: 'GET',
                url: API_URL.TSO + '/shippers/:shipperRefId/balancing-groups',
                params: { id: '@id', shipperRefId: '@shipperRefId' },
                isArray: true
            },
            queryPortfolioCodesOfAssignedShipper: {
                method: 'GET',
                url: API_URL.TSO + '/shippers/:shipperRefId/portfolio-codes',
                params: { id: '@id', shipperRefId: '@shipperRefId' },
                isArray: true
            },
            getCreditLimitSettings: {
                method: 'GET',
                url: API_URL.TSO + '/credit-limit-settings'
            },
            enableCreditLimitsForAuctionsAndFcfs: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/credit-limit-settings/enable-for-auctions-and-fcfs'
            },
            enableCreditLimitsForSecondaryMarket: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/credit-limit-settings/enable-for-secondary-market'
            },
            showCreditLimitsToShippers: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/credit-limit-settings/show-credit-limits-to-shippers'
            },
            deactivateCreditLimitSettings: {
                method: 'POST',
                url: API_URL.TSO + '/credit-limit-settings/deactivate'
            },
            getEnabledSettings: {
                method: 'GET',
                url: API_URL.TSO + '/enabled-settings',
                isArray: true
            },
            deactivateVolumeBasedTariff: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/auction-settings/volume-based-tariff/deactivate'
            },
            updateYearlyVolBasedTariff: {
                method: 'POST',
                url:
                    API_URL.TSO + '/auction-settings/volume-based-tariff/yearly'
            },
            updateQuarterlyVolBasedTariff: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/auction-settings/volume-based-tariff/quarterly'
            },
            updateMonthlyVolBasedTariff: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/auction-settings/volume-based-tariff/monthly'
            },
            updateDailyVolBasedTariff: {
                method: 'POST',
                url: API_URL.TSO + '/auction-settings/volume-based-tariff/daily'
            },
            saveBalancingGroupPortfolioCodeSelection: {
                method: 'POST',
                url: API_URL.TSO + '/balancing-group-portfolio-code-setting'
            },
            saveBalancingGroupPortfolioCodeSetting: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/balancing-group-portfolio-code-setting/:setting'
            },
            getNumberOfNetworkPointsWithEnabledVolumeBasedTariff: {
                method: 'GET',
                url:
                    API_URL.TSO +
                    '/auction-settings/number-of-network-points-with-enabled-volume-based-tariff',
                interceptor: {
                    response: (response: ng.resource.IResourceResponse) =>
                        response.data
                }
            },
            saveRequireBalancingGroupForTransferOfUseTrades: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/balancing-group-portfolio-code-setting/require-balancing-group-for-transfer-of-use'
            },
            saveValidatePortfolioCodeForDirection: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/balancing-group-portfolio-code-setting/validate-portfolio-code-for-direction'
            },
            getBalancingGroupPortfolioCodeSelection: {
                method: 'GET',
                url: API_URL.TSO + '/balancing-group-portfolio-code-setting'
            },
            createContractingService: {
                method: 'POST',
                url: API_URL.TSO + '/contracting-service'
            },
            updateContractingService: {
                method: 'PUT',
                url: API_URL.TSO + '/contracting-service/:contractingServiceId',
                params: { contractingServiceId: '@contractingServiceId' }
            },
            deleteContractingService: {
                method: 'DELETE',
                url: API_URL.TSO + '/contracting-service/:contractingServiceId',
                params: { contractingServiceId: '@contractingServiceId' }
            },
            deleteAllContractingServices: {
                method: 'DELETE',
                url: API_URL.TSO + '/contracting-service'
            },
            saveUnderlyingDealSourceConfig: {
                method: 'PUT',
                url:
                    API_URL.TSO +
                    '/secondary-settings/underlying-deal-sources/:underlyingDealSource'
            },
            saveSelectionPossibilityOfContractIdOnManualUnderlyingDeals: {
                method: 'PUT',
                url:
                    API_URL.TSO +
                    '/secondary-settings/manual-underlying-deal-id-selection'
            },
            saveSupportToPreFillPriceFromUnderlyingDeal: {
                method: 'PUT',
                url:
                    API_URL.TSO +
                    '/secondary-settings/pre-fill-price-from-underlying-deal'
            },
            saveSupportToChangePriceOfUnderlyingDeal: {
                method: 'PUT',
                url:
                    API_URL.TSO +
                    '/secondary-settings/change-price-of-underlying-deal'
            },
            saveSurchargeSelectionPossibility: {
                method: 'PUT',
                url:
                    API_URL.TSO +
                    '/secondary-settings/surcharge-selection-possibility'
            },
            hideRegulatedTariffForUnderlyingDeals: {
                method: 'PUT',
                url:
                    API_URL.TSO +
                    '/secondary-settings/hide-regulated-tariff-for-underlying-deal'
            },
            allowUpdateOfRegulatedTariffForUnderlyingDeals: {
                method: 'PUT',
                url:
                    API_URL.TSO +
                    '/secondary-settings/allow-update-regulated-tariff-for-underlying-deal'
            },
            uploadAdditionalTradingConditions: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/secondary-settings/additional-trading-conditions-document',
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            },
            uploadShipperRegistrationDocument: {
                method: 'POST',
                url: API_URL.TSO + '/registration-settings/shipper-documents',
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            },
            deleteAdditionalTradingConditions: {
                method: 'DELETE',
                url:
                    API_URL.TSO +
                    '/secondary-settings/additional-trading-conditions-document/:tradingConditionId'
            },
            saveValidationPeriod: {
                method: 'PUT',
                url:
                    API_URL.TSO +
                    '/secondary-settings/validation-period/:transactionType'
            },
            querySurrenderSettings: {
                method: 'GET',
                isArray: false,
                url: API_URL.TSO + '/surrender-settings'
            },
            deactivateSurrenderSettings: {
                method: 'POST',
                url: API_URL.TSO + '/surrender-settings/deactivate'
            },
            saveEnableSurrenderForShortTerm: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/surrender-settings/save-enable-surrender-for-short-term'
            },
            saveEnableSurrenderForLongTerm: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/surrender-settings/save-enable-surrender-for-long-term'
            },
            saveContractIdSelection: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/surrender-settings/save-contract-id-selection'
            },
            saveReceiveCopyOfConfirmationMail: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/surrender-settings/save-receive-copy-of-confirmation-mail'
            },
            saveAllowForPendingShippers: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/surrender-settings/save-allow-for-pending-shippers'
            },
            saveHourForMinimalLeadTime: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/surrender-settings/save-hour-for-minimal-lead-time'
            },
            saveMinuteForMinimalLeadTime: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/surrender-settings/save-minute-for-minimal-lead-time'
            },
            saveMinimalLeadTime: {
                method: 'POST',
                url: API_URL.TSO + '/surrender-settings/save-min-lead-time'
            },
            saveExpectMultipleOfAMonth: {
                method: 'POST',
                url: API_URL.TSO + '/surrender-settings/save-multiple-of-month'
            },
            queryShipperRegistrationDocuments: {
                method: 'GET',
                isArray: true,
                url: API_URL.TSO + '/registration-settings/shipper-documents'
            },
            deleteTsoDocument: {
                method: 'DELETE',
                url:
                    API_URL.TSO +
                    '/registration-settings/shipper-documents/:tsoDocumentId'
            },
            queryDocuments: {
                method: 'GET',
                isArray: true,
                url: API_URL.TSO + '/documents',
                params: { id: '@id', category: '@category' }
            },
            deleteAllDocuments: {
                method: 'DELETE',
                url: API_URL.TSO + '/documents',
                params: { id: '@id', category: '@category' }
            },
            disableSecondaryFlexibleLeadTimeRules: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/secondary-settings/disable-flexible-lead-times'
            },
            queryExtraRegistrationForm: {
                method: 'GET',
                isArray: false,
                url: API_URL.TSO + '/registration-settings/extra-form'
            },
            saveExtraRegistrationForm: {
                method: 'POST',
                url: API_URL.TSO + '/registration-settings/extra-form'
            },
            previewExtraRegistrationForm: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/registration-settings/extra-form/preview/generate'
            },
            deleteExtraRegistrationForm: {
                method: 'DELETE',
                url: API_URL.TSO + '/registration-settings/extra-form'
            },
            queryMarketAreaNotifications: {
                method: 'GET',
                isArray: true,
                url: API_URL.TSO + '/market-area-assignments'
            },
            toggleMarketAreaMailOnShipperRegistration: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/market-area-assignments/:assignmentRefId/toggle-mail-on-shipper-registration'
            },
            deactivateAllMarketAreaNotifications: {
                method: 'POST',
                url:
                    API_URL.TSO +
                    '/market-area-assignments/deactivate-all-notifications'
            },
            queryUsers: {
                method: 'GET',
                isArray: true,
                url: API_URL.TSO + '/user-assignments'
            },
            getTsoUser: {
                method: 'GET',
                url: API_URL.TSO + '/users/:tsoUserRefId'
            },
            updateTsoUser: {
                method: 'PUT',
                url: API_URL.TSO + '/users/:tsoUserRefId'
            },
            activateTsoUser: {
                method: 'POST',
                url: API_URL.TSO + '/users/:tsoUserRefId/activate'
            },
            deactivateTsoUser: {
                method: 'POST',
                url: API_URL.TSO + '/users/:tsoUserRefId/deactivate'
            },
            toggleAdminTsoUser: {
                method: 'PUT',
                url: API_URL.TSO + '/users/:tsoUserRefId/role-change'
            },
            prepareTsoUsersListPdf: {
                method: 'POST',
                url: API_URL.TSO + '/user-assignments/export/pdf'
            },
            prepareTsoUsersListCsv: {
                method: 'POST',
                url: API_URL.TSO + '/user-assignments/export/csv'
            },
            prepareTsoUserDetailsAndAssignmentPdf: {
                method: 'POST',
                url: API_URL.TSO + '/users/:tsoUserRefId/export/pdf'
            },
            prepareTsoUserDetailsAndAssignmentCsv: {
                method: 'POST',
                url: API_URL.TSO + '/users/:tsoUserRefId/export/csv'
            },
            deleteAllAdditionalConditions: {
                method: 'DELETE',
                url:
                    API_URL.TSO +
                    '/secondary-settings/additional-trading-conditions-document'
            },
            getContactEmails: {
                method: 'GET',
                isArray: false,
                url: API_URL.TSO + '/contact-emails'
            },
            deleteAllTsoDocuments: {
                method: 'DELETE',
                url: API_URL.TSO + '/registration-settings/shipper-documents'
            }
        }
    );
}
